module.exports = __webpack_public_path__ + "cd85a2410d1ec8fa3ef0f96d4382a0f5.MP3";